/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './admin-blacklists.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../app/admin/admin-blacklists/admin-blacklists.component';
const styles_AdminBlacklistsComponent:any[] = [i0.styles];
export const RenderType_AdminBlacklistsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_AdminBlacklistsComponent,data:{}});
export function View_AdminBlacklistsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AdminBlacklistsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-admin-blacklists',
      ([] as any[]),(null as any),(null as any),(null as any),View_AdminBlacklistsComponent_0,
      RenderType_AdminBlacklistsComponent)),i1.ɵdid(1,114688,(null as any),0,i3.AdminBlacklistsComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AdminBlacklistsComponentNgFactory:i1.ComponentFactory<i3.AdminBlacklistsComponent> = i1.ɵccf('app-admin-blacklists',
    i3.AdminBlacklistsComponent,View_AdminBlacklistsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9hZG1pbi1ibGFja2xpc3RzL2FkbWluLWJsYWNrbGlzdHMuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9hZG1pbi1ibGFja2xpc3RzL2FkbWluLWJsYWNrbGlzdHMuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL2FkbWluLWJsYWNrbGlzdHMvYWRtaW4tYmxhY2tsaXN0cy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9hZG1pbi1ibGFja2xpc3RzL2FkbWluLWJsYWNrbGlzdHMuY29tcG9uZW50LnRzLkFkbWluQmxhY2tsaXN0c0NvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD4iLCI8YXBwLWFkbWluLWJsYWNrbGlzdHM+PC9hcHAtYWRtaW4tYmxhY2tsaXN0cz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7YUFBQTswREFBQTtVQUFBO0lBQUE7Ozs7b0JDQUE7TUFBQTt5Q0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/admin-blacklists/admin-blacklists.component.ngfactory.ts